import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const intakeSteps = (ctx: TourStepContext): StepType[] => {
  const steps: StepType[] = [
    {
      selector: '[data-tour="intake-table"]',
      content:
        'A lista de fichas de triagem (Bridge 0) mostra todas as demandas recebidas antes de evoluírem para um projeto formal. Cada ficha contém o escopo inicial, responsável e complexidade estimada.',
    },
    {
      selector: '[data-tour="intake-filters"]',
      content:
        'Use os filtros para encontrar fichas por status (Pendente, Em análise, Aprovada, Rejeitada), tipo de projeto ou complexidade.',
    },
  ];

  if (ctx.hasPermission('edit_read_delete')) {
    steps.push({
      selector: '[data-tour="intake-new-btn"]',
      content:
        'Clique aqui para registrar uma nova demanda. Preencha o formulário com as informações iniciais — título, requisitante, tipo e benefício esperado.',
    });
  }

  return steps;
};
